module.exports = __webpack_public_path__ + "img/login-barriorojas.fe032d83.svg";